import { Button, Skeleton } from "@heroui/react";
import { CopyIcon, UnplugIcon } from "lucide-react";
import { toast } from "sonner";
import { type Address, formatUnits } from "viem";
import { useAccount, useBalance, useDisconnect } from "wagmi";
import TokenBrandedMetamask from "~icons/token-branded/metamask";
import { shortHex } from "../../utils";
import ConnectEthWalletModal from "./../ConnectWalletModal";

export function EthWallet() {
  const account = useAccount();

  if (account.status === "disconnected") {
    return <ConnectEthWalletModal />;
  }

  if (account.status === "connected") {
    return <EthWalletConnected address={account.address} />;
  }

  return "Loading Eth Wallet...";
}

function EthWalletConnected({ address }: { address: Address }) {
  const balanceQuery = useBalance({
    address,
  });

  const { disconnect } = useDisconnect();

  return (
    <div className="flex justify-between bg-[#2E526C] p-4 rounded-xl">
      <div className="flex flex-col gap-2">
        <TokenBrandedMetamask className="size-12" />

        <div className="flex flex-col">
          <div className="text-small">Connected EVM</div>

          <div className="text-lg font-semibold">
            {shortHex(address)}
            <Button
              variant="light"
              size="sm"
              isIconOnly
              onPress={() => {
                navigator.clipboard.writeText(address);
                toast.info("Address copied to clipboard");
              }}
            >
              <CopyIcon className="text-[#799AB3] size-4" />
            </Button>
          </div>
        </div>
      </div>

      <div className="flex flex-col items-end justify-between gap-2">
        <Button variant="flat" size="sm" isIconOnly onPress={() => disconnect()}>
          <UnplugIcon className="text-[#799AB3]" />
        </Button>

        <div className="flex flex-col items-end">
          <div className="text-small">Balance</div>

          {balanceQuery.data ? (
            <div className="text-lg font-semibold">
              {Number(formatUnits(balanceQuery.data.value, balanceQuery.data.decimals)).toFixed(2)}{" "}
              {balanceQuery.data.symbol}
            </div>
          ) : (
            <Skeleton className="rounded-lg h-8 w-20 !bg-slate-100 !bg-opacity-50" />
          )}
        </div>
      </div>
    </div>
  );
}
